// ---------------------------------------------- modules import
import { ThunkAction } from "redux-thunk";

import Actions from "./actions";
import { IPinnedPost, PinnedPostAction } from "./common";
import { AppState } from "../rootReducer";
import PermissionHelper from "../helpers/permissionHelper";
import { IThunkExtraArgument } from "../../index";

// ---------------------------------------------- thunk actions
export const thunkUpdatePinnedPost = (
  pinnedPost: IPinnedPost
): ThunkAction<void, AppState, IThunkExtraArgument, PinnedPostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { id, ...data } = pinnedPost;

  dispatch(Actions.updateBegin());

  firebase
    .firestore()
    .collection("pinnedPosts")
    .doc(id)
    .update(data)
    .then(() => dispatch(Actions.updateSuccess()))
    .catch(error => dispatch(Actions.updateError(error.message)));
};

export const thunkUnpinPinnedPost = (
  pinnedPost: IPinnedPost
): ThunkAction<void, AppState, IThunkExtraArgument, PinnedPostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const collectionPath = PermissionHelper.getCollection(pinnedPost.indexOrigin);
  const { id, pinnedAt, indexOrigin, ...data } = pinnedPost;

  dispatch(Actions.unpinBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .doc(id)
    .set(data)
    .then(() => {
      firebase
        .firestore()
        .collection("pinnedPosts")
        .doc(id)
        .delete()
        .then(() => dispatch(Actions.unpinSuccess()))
        .catch(error => dispatch(Actions.unpinError(error.message)));
    })
    .catch(error => dispatch(Actions.unpinError(error.message)));
};
